module.exports = __webpack_public_path__ + "img/dialogue_load.f071d4a7.gif";